interface FAQItem {
  question: string;
  answer: string;
}



export const categoryFaqs: Record<Category, FAQItem[]> = {
  general: [
    {
      question: "1. What is Sowphie?",
      answer: "• Sowphie is a smart farm management assistant designed to help commercial farmers in Kenya manage their farms efficiently. It provides crop advisory, financial tracking, access to high quality farm inputs, credit financing, and expert consultation."
    },
    {
      question: "2. Who is Sowphie for?",
      answer: "• Sowphie is built for commercial farmers in Kenya, especially those managing farms remotely and seeking better access to advisory, finance, and operational insights."
    },
    {
  question: "3. How does Sowphie help farmers?",
  answer: `Sowphie helps farmers by:
      • Crop Calendars: Providing a wide variety of expertly crafted crop guides with task reminders.
      • Bookkeeping: Tracking income and expenses.
      • Access to Quality Inputs: Connecting farmers with verified suppliers of quality inputs.
      • Sowphie AI Chatbot: Answering Your Crop and Livestock Management Questions Instantly.
      • Credit: Providing Agri-Finance linkages while also assisting farmers with credit scoring and credit advisory for better financial access.`
},
    {
      question: "4. Who does Sowphie work with?",
      answer: `• Agro-Input Suppliers, Distributors and Retail Outlets: Sowphie offers Farm Management Advisory and Input Recommendations to farmers based on their tasks and needs.
• Agronomy and Veterinary Service Providers: Sowphie partners with Experts in Agriculture to provide accurate insights and recommendations to farmers.
• Other Agro-Value Chain Service Providers: Sowphie provides a diverse network of farmers who need farm and/or produce-related services regularly (E.g. Logistics, Tractor Services, etc.)
• Credit and Insurance Providers: Sowphie enables farmers to financially track their farm activities, with the support of crop and livestock insurance. Sowphie also offers credit advisory and linkages to farmers.`
    }
  ],
  farm_advisory: [
    {
      question: "1. What is the Sowphie AI Chatbot?",
      answer: "• The Sowphie AI Chatbot is a virtual assistant that provides AI-powered responses to general farming questions. It helps farmers with crop management, livestock care, and farm planning by offering real-time insights based on available agricultural data."
    },
    {
      question: "2. Which farm management features does Sowphie offer?",
      answer: `• Step-by-Step Crop Management Calendars: Guides farmers on what to do, when, what inputs to use and where to source them.
• Remote Sensors:  With the use Internet-of-Things Technology (IoT), soil and weather sensors provide farmers with real-time data on their soil health and prevailing weather conditions in their farms.
• Task Scheduling & Reminders: Alerts farmers about key farming tasks, and follows up on what is completed.
• Geolocation-Based Supplier Suggestions – Helps farmers find agro-input suppliers nearest their farms.
• Progress Tracking – Monitors crop management and progress, enabling farmers to remotely supervise their farms.`
    },
    {
      question: "3. Does the chatbot provide recommendations on fertilizers, pesticides, or livestock feed?",
      answer: "• Yes, the chatbot can suggest commonly used inputs based on the crop stage or livestock care routine. However, always consult a certified expert before applying any farm inputs."
    },
    {
      question: "4. How accurate is the advice from the chatbot and crop calendar?",
      answer: "• The chatbot and crop calendar provide AI-generated insights based on agricultural data, but they are not a replacement for professional advice. Always verify information with an expert before making critical decisions."
    },
    {
      question: "5. Can I customize my crop calendar?",
      answer: "• Yes, you can tailor your crop calendar by selecting specific crops and setting reminders for tasks such as planting, watering, and harvesting among other tasks."
    },
    {
      question: "6. Can the chatbot diagnose crop diseases or livestock health issues?",
      answer: "• No, the chatbot can provide general guidance on common symptoms, but it does not diagnose diseases. For serious health issues, consult a certified agricultural professional."
    },
    {
        question: "7. Is this service free?",
        answer: "• YES! The crop calendar features are free to use. However, we also have premium features that offer real-time advisory from IoT systems on your farm, chatbot inquiry support and call services for expert consultations."
  
    }
      ],
  financial_services: [
    {
      question: "1. Which financial management features does Sowphie offer?",
      answer: `Sowphie provides comprehensive financial tools to help farmers track and manage their income, expenses, and overall farm profitability. Key features include:
• Multi-User Financial Management: Farm owners and managers can jointly update a single account, ensuring real-time financial tracking with role-based access.
• Income & Expense Tracking: Record daily financial transactions.
• Custom Chart of Accounts: Categorize expenses and revenues for better organization.
• Receipt Attachment: Upload receipts for easy bookkeeping.
• Financial Reporting: Generate farm-specific profit and loss reports.`
    },
    {
      question: "2. How does Sowphie help farmers manage cash flow?",
      answer: `• Monitor daily expenses and earnings.
• Identify areas where you’re overspending.
• Forecast future revenue and costs based on farm activities.`
    },
    {
        question: "3. Can I link my bank account or mobile money to Sowphie?",
      answer: "• No, Sowphie does not currently integrate with bank accounts or mobile money platforms. However, you can manually log transactions to track your financial health."
    },
    {
        question: "4. Can multiple users manage the farm’s financial records?",
      answer: "• Yes, Sowphie supports multi-user access with permission controls. You can grant financial visibility to farm managers and accountants while keeping sensitive data private."
    },
    {
        question: "5. Does Sowphie provide automated financial reports?",
      answer: `
Yes, Sowphie generates automated reports, including:
• Profit & Loss Statements
• Balance Sheets
• Income and Expense Summaries`
    },
    {
        question: "6. Can I use Sowphie for tax filing?",
      answer: "• Yes, Sowphie helps organize your farm’s financial records, making tax preparation easier. Sowphie offers a separate premium service for tax filing and audit services."
    },
    {
        question: "7. Can I access financial data offline?",
      answer: "• Sowphie stores data locally on your device for offline access. However, full financial features require an internet connection to sync across devices."
    },
    {
        question: "8. How does Sowphie help farmers access financing?",
      answer: "• Sowphie connects farmers with agri-financiers by assessing their creditworthiness and providing insights to improve their chances of securing funding."
    },
    {
        question: "9. What is the credit scoring feature in Sowphie?",
      answer: `
Sowphie generates a data-driven credit score based on:
• Farm operations and management history.
• Financial records such as income and expense tracking.
• Transaction activity related to farm inputs and outputs.
• Additional structured data (e.g., land ownership, collateral, business history).`
    },
    {
        question: "10. How does Sowphie help improve my credit score?",
      answer:`Sowphie provides actionable steps to boost your credit score, such as:
• Maintaining accurate financial records of farm transactions.
• Ensuring consistent farm operations tracking.
• Improving expense and income management.
• Adding key financial details such as land ownership and business history.`
    },
    {
        question: "11. Can I apply for financing directly through Sowphie?",
      answer: "• Yes! Sowphie allows farmers to explore financing options within the app. We partner with agri-financiers and agri-investors. Farmers are able to apply for loans directly through our platform, based on their credit score and financial records. It is important to note that your data is private and secure, and is not shared with third-parties without your consent."
    },
    {
        question: "12. Can Sowphie guarantee I will get a loan?",
      answer: "• No, Sowphie does not guarantee loans, but it helps farmers understand their creditworthiness and connect with potential financiers who may offer financing based on their credit profile."
    },
    {
        question: "13. Does Sowphie work with specific agri-financiers?",
      answer: "• Yes, Sowphie partners with various financial institutions and lenders who specialize in agricultural financing. Farmers can explore financing options based on their credit score and financial records. However, we do not share our farmers’ private data to third-parties without their consent."
    },
    {
        question: "14. Does using Sowphie guarantee my credit score will increase?",
      answer: "• Sowphie provides insights and tools to help improve your creditworthiness, but the actual score increase depends on your financial discipline and farm management practices."
    }
],
  data_privacy: [
    {
      question: "1. How does Sowphie protect my data?",
      answer: `Sowphie uses industry-standard security measures, including:
• Encryption: Your data is encrypted to prevent unauthorized access.
• Secure Authentication: We use strong authentication methods to protect your account.
• Role-Based Access Control: You control who can access your farm data.`
    },
    {
      question: "2. Who has access to my farm data?",
      answer: "• Only you and the people you authorize (e.g., farm managers, employees) can access your farm data. We do not share your personal data with third parties without your consent."
    },
    {
        question: "3. Does Sowphie sell my data?",
      answer: "• No. Sowphie does not sell, rent, or trade your personal or farm data to any third party."
    },
    {
        question: "4. Can I delete my data if I stop using Sowphie?",
      answer: "• Yes. You can request to delete your account and all associated data at any time."
    },
    {
        question: "5. Will Sowphie access my phone’s location or contacts?",
      answer: "• Sowphie may request location access to suggest nearby suppliers. However, this is optional, and we do not track or share your location. We do not access your contacts."
    }
  ]
};

// Helper object to map technical names to display names
export const categoryDisplayNames: Record<Category, string> = {
  general: "General",
  farm_advisory: "Advisory",
  financial_services: "Bookkeeping",
  data_privacy: "Data Privacy"
};

// Helper type for category keys
export type Category = 'general' | 'farm_advisory' | 'financial_services' | 'data_privacy';

export const expandedSectionTitles: Record<Category, string> = {
  general: "General Inquiries",
  farm_advisory: "Farm Advisory Services",
  financial_services: "Financial Services & Bookkeeping",
  data_privacy: "Data Privacy & Security",
};
